import angular from 'angular';
import { sqManualConditionStore } from '@/hybrid/tools/manualCondition/manualCondition.store';

angular.module('Sq.Investigate').store('sqManualConditionStore', sqManualConditionStore);
